import { FC } from "react";
import { useTranslation } from "react-i18next";
import { useRechargeSummary } from "../../hooks/useRechargeSummary";
import RechargeButton from "./RechargeButton";

export const SummaryRow: FC<{ label: string; value: string; bold?: boolean }> = ({ label, value, bold }) => {
  return (
    <div className="flex items-center justify-between">
      <div className={bold ? "text-sm font-semibold" : "text-font-subtle text-sm"}>{label}</div>
      <div className={bold ? "text-sm font-semibold" : "text-font-subtle text-sm"}>{value}</div>
    </div>
  );
};

export default function TopupSummary() {
  const { t } = useTranslation();
  const { serviceValue, serviceFeesDisplay, totalAmount, points, currency } = useRechargeSummary();

  return (
    <div className="flex h-full flex-col gap-8 p-4 py-8 font-manrope">
      <div className="text-lg font-semibold border-border-default border-b p-2 font-manrope">{t("Topup.paymentSummary")}</div>
      <div className="border-border-default flex flex-col gap-3 border-b pb-6">
        <SummaryRow label={t("Topup.serviceValue")} value={`${serviceValue} ${currency}`} />
        <SummaryRow label={t("Topup.serviceFees")} value={serviceFeesDisplay} />
      </div>
      <div className="flex flex-col gap-3">
        <SummaryRow label={t("Topup.youWillGet")} value={`${serviceValue} ${currency}`} bold />
        <SummaryRow label={t("Topup.totalAmount")} value={`${totalAmount} ${currency}`} bold />
        <SummaryRow label={t("Topup.pointsRequired")} value={`${points} ${t("Topup.pointsSuffix")}`} bold />
      </div>
      <div className="flex h-full items-end justify-center">
        <RechargeButton serviceValue={serviceValue} serviceFeesDisplay={serviceFeesDisplay} totalAmount={totalAmount} points={points} currency={currency} />
      </div>
    </div>
  );
}
